// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.LoadingIndicator.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from './Izenda.Loading';
import LoadingManager from 'modules/Izenda.LoadingManager';
import connect from 'share/enhancers/Izenda.Connect';

@connect()
export default class LoadingIndicator extends Component {
  static propTypes = {
    loader: PropTypes.object.isRequired
  };

  constructor(props: any) {
    super(props);

    this.state = {
      show: false
    };

    this.isMountedStatus = false;
    this.unregister = props.loader.registerLoadingChanged(this.onLoadingChanged);
  }

  componentDidMount() {
    this.isMountedStatus = true;
  }

  componentWillUnmount() {
    this.unregister();
    this.isMountedStatus = false;
  }

  render() {
    return (
      <Loading show={this.state.show} onCancel={this.onCancel} allowToCancelProgress={this.allowToCancelProgress} />
    );
  }

  onLoadingChanged = (loading: boolean, loadingProps: any) => {
    this.loadingProps = loadingProps || {};
    this.isMountedStatus &&
      this.setState({
        show: loading
      });
  };

  onCancel = () => {
    LoadingManager.cancelLoading(this.props.loader);
  };

  allowToCancelProgress = () => {
    // loading is mapped to global mapping (show/hide though PageService & LoadingIndicator)
    return LoadingManager.allowToCancelGlobalProgress(this.props.loader);
  };
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.LoadingIndicator.js